import type { BancoDoCatalogo } from "@/api/contrato";
import type { GrupoDeOpcoes } from "@/componentes/Selecao";

/*
 * O catálogo de bancos como opções de `Selecao`, para o formulário de conta e para o
 * filtro de banco das listas.
 *
 * Os que têm ficha vêm primeiro, porque são os que emitem: Sicoob, depois Sicredi. O
 * resto segue a ordem do catálogo, marcado no próprio rótulo: o `<optgroup>` some da
 * leitura depois de escolhido, e o rótulo fica.
 */
export function gruposDeBancos(bancos: readonly BancoDoCatalogo[]): GrupoDeOpcoes[] {
  const comFicha = bancos
    .filter((banco) => banco.tem_perfil_de_ficha)
    .sort((a, b) => b.codigo.localeCompare(a.codigo));
  const semFicha = bancos.filter((banco) => !banco.tem_perfil_de_ficha);

  return [
    {
      rotulo: "Com ficha",
      opcoes: comFicha.map((banco) => [banco.codigo, `${banco.codigo} ${banco.nome}`] as const),
    },
    {
      rotulo: "Sem ficha",
      opcoes: semFicha.map(
        (banco) => [banco.codigo, `${banco.codigo} ${banco.nome} · sem ficha`] as const,
      ),
    },
  ];
}

/** A linha do catálogo de um banco. `undefined` em banco que saiu do catálogo. */
export function bancoDoCatalogo(
  bancos: readonly BancoDoCatalogo[],
  codigo: string,
): BancoDoCatalogo | undefined {
  return bancos.find((banco) => banco.codigo === codigo);
}
